<template>
  <div class="user-list">
    <div class="item" v-for="item of list" :key="item.userUuid">
      <div class="avatar-box" @click="toPlayerDetail(item.userUuid)">
        <img class="avatar" :src="$util.setImageSize(item.avatarURL,100,100)" alt="" />
        <img
          class="avatar-frame"
          :src="getAvatarFrame(item)"
          alt=""
          v-if="getAvatarFrame(item)"
        />
      </div>
      <div class="right">
        <div class="user-level-wrap">
          <div
            class="userlevel-tag"
            v-if="item.userLevel"
            :class="`level-${item.userLevel}`"
          ></div>
        </div>
        <span>{{ item.nickname }}</span>
      </div>
    </div>
    <!-- <div class="item">
      <div class="avatar-box">
        <img
          class="avatar"
          src="https://resource.funplus.social/user-static/2bad32d0-dbfe-4fa8-95a3-b77740170a552771753387358337811.png"
          alt=""
        />
      </div>
      <div class="right">
        <div class="user-level-wrap">
          <div class="userlevel-tag" :class="`level-11`"></div>
        </div>
        <span>测测</span>
      </div>
    </div> -->
  </div>
</template>
<script>
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import SeatProvider from '@/components/VoiceRoom/seatProvider';

export default {
  name: 'OnlineMembers',
  props: {},
  data() {
    return {
      list: [],
      pageIndex: null,
      nextPageIndex: null,
      pageTotal: null,
      loading: false,
      interval: null
    };
  },
  watch: {
    roomId: {
      handler: function() {
        this.getList();
      },
      immediate: true
    }
  },
  computed: {
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    }
  },
  created() {
    VoiceRoomEventEmitter.on(VoiceRoomEvent.leaveRoom, () => {
      this.getList();
    });
    VoiceRoomEventEmitter.emit(VoiceRoomEvent.joinRoom, () => {
      this.getList();
    });
   this.interval = setInterval(() => {
      this.getList();
    }, 15000);
  },
  methods: {
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    async getList() {
      try {
        if (this.loading) {
          return;
        }
        if (!this.roomId) {
          return;
        }
        this.loading = true;
        const { data } = await this.$http.get('/voiceRoom/getOnlineUsers', {
          roomUid: this.roomId
        });
        this.list = data || [];
        VoiceRoomProvider.setMemberList(this.list);
        SeatProvider.updateScore(this.list);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getAvatarFrame(userInfo) {
      return userInfo.pfpFrame && JSON.parse(userInfo.pfpFrame)
        ? JSON.parse(userInfo.pfpFrame).url
        : '';
    }
  },
  destroyed() {
    if(this.interval){
      clearInterval(this.interval);
      this.interval = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.user-list {
  width: 100%;
  // background-color: #2f315c;
  height: 100%;
  overflow: scroll;
  @include hideScrollBar(0, 0);
}
.item {
  display: flex;
  align-items: center;
  padding: 24px;
  .avatar-box {
    flex: none;
    display: flex;
    align-items: center;
    position: relative;
    width: 40px;
    height: 40px;
  }
  .avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
  .avatar-frame {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.43);
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
}
.right {
  margin-left: 10px;
  font-size: 14px;
}
</style>
